export const fieldsTranslationsEs = {
  'fields-parameters.navbar.services.title': 'Servicios',
  'fields-parameters.title': 'Parámetros de parcelas',
  'fields-parameters.services.table.title': 'Parcelas',
  'service.field_parameters.column.farmer_name.label': 'Explotación',
  'service.field_parameters.column.field_number.label': 'Número de parcelas',
  'service.field_parameters.column.total_area.label': 'Superficie total (ha)',
  'service.field_parameters.detail_panel.column.field_name.label': 'Nombre de la parcela',
  'service.field_parameters.detail_panel.column.area.label': 'Superficie (ha)',
  'service.field_parameters.detail_panel.column.service.label': 'Servicio',
  'service.field_parameters.detail_panel.column.crop.label': 'Cultivo',
  'service.field_parameters.detail_panel.column.subscription.label': 'Suscripción',
  'service.field_parameters.detail_panel.column.subscription.active.label': 'Activo',
  'service.field_parameters.detail_panel.column.subscription.no_subscription.label': 'Sin suscripción',
  'service.field_parameters.detail_panel.column.service.button.parameter.label': 'Parámetros',
  'irrigation_field_service_parameters.button.undo.label': 'Deshacer cambios',
  'irrigation_field_service_parameters.button.save.label': 'Guardar cambios',
  'irrigation_field_service_parameters.multiple_edition.button.apply.label': 'Aplicar',
  'irrigation_field_service_parameters.multiple_edition.button.clear.label': 'Borrar',
  'irrigation_field_service_parameters.multiple_edition.title.label': 'Edición de varias parcelas',
  'irrigation_field_service_parameters.multiple_edition.info.setp1':
    '1- Rellene los campos que desea aplicar a varias parcelas',
  'irrigation_field_service_parameters.multiple_edition.info.setp2':
    '2- Seleccione las parcelas a las que desea aplicar los parámetros',
  'irrigation_field_service_parameters.multiple_edition.info.setp3':
    '3- Confirme haciendo clic en el botón aplicar (Atención: pueden aparecer errores)',
  'irrigation_field_service_parameters.multiple_edition.info.setp4': '4- Guarde para aplicar su actualización',
  'irrigation_field_service_parameters.table.Column.farmer_name.label': 'Explotación',
  'irrigation_field_service_parameters.table.Column.field_number.label': 'Número de parcelas',
  'irrigation_field_service_parameters.table.Column.total_area.label': 'Superficie total (ha)',
  'irrigation_field_service_parameters.table.detail_panel.column.field.label': 'Parcela',
  'irrigation_field_service_parameters.table.detail_panel.column.soil.label': 'Suelo',
  'irrigation_field_service_parameters.table.detail_panel.column.weather_station.label': 'Estación meteorológica',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_management.label': 'Gestión del riego',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_threshold.label': 'Umbral de riego',
  'irrigation_field_service_parameters.table.detail_panel.column.assolment.label': 'Rotación de cultivos',
  'fields-parameters.dialog.error.title': 'Error al guardar',
  'fields-parameters.dialog.error.legend': 'Algunas de sus modificaciones han encontrado errores y no se han guardado.',
  'fields-parameters.dialog.error.contact':
    'Si el problema persiste, por favor envíe estos errores a nuestro servicio de soporte en la dirección csm@pixagri.fr',
};
